document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('a[href^="#"]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();var t=document.querySelector(this.getAttribute('href'));if(t){t.scrollIntoView({behavior:'smooth'})}})});var toggle=document.getElementById('mobileMenuToggle');var nav=document.getElementById('megaNav');if(toggle&&nav){toggle.addEventListener('click',function(){nav.classList.toggle('mobile-open')})}document.querySelectorAll('.mega-toggle').forEach(function(btn){btn.addEventListener('click',function(e){e.preventDefault();var li=btn.closest('.mega-nav-item');var isOpen=li.classList.contains('open');document.querySelectorAll('.mega-nav-item.open').forEach(function(openLi){if(openLi!==li){openLi.classList.remove('open');var ob=openLi.querySelector('.mega-toggle');if(ob){ob.setAttribute('aria-expanded','false')}}});li.classList.toggle('open',!isOpen);btn.setAttribute('aria-expanded',String(!isOpen))})});document.addEventListener('click',function(e){if(!e.target.closest('.mega-nav-item')){document.querySelectorAll('.mega-nav-item.open').forEach(function(li){li.classList.remove('open');var b=li.querySelector('.mega-toggle');if(b){b.setAttribute('aria-expanded','false')}})}})});
document.addEventListener('DOMContentLoaded',function(){
document.querySelectorAll('.product-gallery').forEach(function(gallery){
  var thumbs=gallery.querySelectorAll('.product-gallery-thumb');
  var images=gallery.querySelectorAll('.product-gallery-image');
  thumbs.forEach(function(thumb){
    thumb.addEventListener('click',function(){
      var idx=thumb.getAttribute('data-index');
      thumbs.forEach(function(t){t.classList.remove('active')});
      images.forEach(function(i){i.classList.remove('active')});
      thumb.classList.add('active');
      var img=gallery.querySelector('.product-gallery-image[data-index="'+idx+'"]');
      if(img){img.classList.add('active')}
    });
  });
});

document.querySelectorAll('.product-form').forEach(function(form){
  var panel=form.closest('.product-details-panel');
  var variantsScript=panel?panel.querySelector('[data-product-variants]'):null;
  var variantsData=variantsScript?JSON.parse(variantsScript.textContent):[];
  var variantIdInput=form.querySelector('[data-variant-id]');
  var priceEl=panel?panel.querySelector('[data-product-price]'):null;
  var addBtn=form.querySelector('[data-add-to-cart]');
  var gallery=form.closest('.product-layout')?form.closest('.product-layout').querySelector('.product-gallery'):null;
  var optionGroups=form.querySelectorAll('.product-option');
  var selected={};

  optionGroups.forEach(function(group){
    var idx=group.getAttribute('data-option-index');
    var selectedBtn=group.querySelector('.product-option-value.selected');
    selected[idx]=selectedBtn?selectedBtn.getAttribute('data-value'):null;
    group.querySelectorAll('.product-option-value').forEach(function(btn){
      btn.addEventListener('click',function(){
        group.querySelectorAll('.product-option-value').forEach(function(b){b.classList.remove('selected')});
        btn.classList.add('selected');
        selected[idx]=btn.getAttribute('data-value');
        updateVariant();
      });
    });
  });

  function updateVariant(){
    if(!variantsData.length) return;
    var match=variantsData.find(function(v){
      return Object.keys(selected).every(function(idx){
        var optKey='option'+(parseInt(idx,10)+1);
        return v[optKey]===selected[idx];
      });
    });
    if(!match) return;
    if(variantIdInput){variantIdInput.value=match.id}
    if(priceEl){
      priceEl.innerHTML=match.price>0?match.price_formatted:'<span class="product-price-quote">Precio sobre cotizacion</span>';
    }
    if(addBtn){
      addBtn.disabled=!match.available;
      addBtn.textContent=match.available?addBtn.getAttribute('data-available-text')||'Agregar al carrito':'Agotado';
    }
    if(gallery&&match.featured_image){
      var targetImg=gallery.querySelector('.product-gallery-image[data-image-src="'+match.featured_image+'"]');
      if(targetImg){
        var idx=targetImg.getAttribute('data-index');
        gallery.querySelectorAll('.product-gallery-image').forEach(function(i){i.classList.remove('active')});
        gallery.querySelectorAll('.product-gallery-thumb').forEach(function(t){t.classList.remove('active')});
        targetImg.classList.add('active');
        var thumb=gallery.querySelector('.product-gallery-thumb[data-index="'+idx+'"]');
        if(thumb){thumb.classList.add('active')}
      }
    }
  }

  var qtyInput=form.querySelector('[data-qty-input]');
  var qtyMinus=form.querySelector('[data-qty-minus]');
  var qtyPlus=form.querySelector('[data-qty-plus]');
  if(qtyMinus&&qtyInput){
    qtyMinus.addEventListener('click',function(){
      var v=parseInt(qtyInput.value,10)||1;
      if(v>1){qtyInput.value=v-1}
    });
  }
  if(qtyPlus&&qtyInput){
    qtyPlus.addEventListener('click',function(){
      var v=parseInt(qtyInput.value,10)||1;
      qtyInput.value=v+1;
    });
  }
});
});
